// Import the generated route tree
import type { RouterLinkProps } from "@/components/Action.tsx";
import { addDevVars } from "@/dev/initDev.ts";
import { RouterErrorFallback } from "@/modules/error/RouterErrorFallback.tsx";
import { basepath } from "@/modules/main/urls.ts";
import { routeTree } from "@/routeTree.gen";
import { createRouter } from "@tanstack/react-router";

export function createStandardRouter() {
    const router = createRouter({
        routeTree,
        basepath,

        defaultErrorComponent: RouterErrorFallback,
        // By default, this option delays the rendering of everything by 500ms (!!!). Disable it with prejudice.
        defaultPendingMinMs: 0,

        // Preload routes on hover
        defaultPreload: "intent",
    });
    addDevVars({ router });
    return router;
}

// Register the router instance for type safety
declare module "@tanstack/react-router" {
    interface Register {
        router: ReturnType<typeof createStandardRouter>;
    }
}

declare module "react-aria-components" {
    interface RouterConfig {
        routerOptions: RouterLinkProps;
    }
}
